export default function ServerCommunicationErrorPage(props: {
  reloadApplication?: () => void;
}) {
  const reloadApplication = props.reloadApplication || (() => {
    window.location.assign("/");
  });

  return (
    <div className="mt-4">
      <div className="row">
        <div className="col-10 offset-1">
          <div className="alert alert-danger" role="alert">
            <h1 className="h4 alert-heading mb-3">
              <i className="bi bi-exclamation-triangle-fill me-2"></i>
              Wystąpił błąd podczas komunikacji z serwerem
            </h1>
            <p>
              Nie udało się pobrać danych wymaganych do działania tej strony.
              Odśwież aplikację i spróbuj ponownie.
            </p>
            <hr />
            <p className="mb-3">
              Jeśli problem się powtórzy, zgłoś incydent do centrum wsparcia.
            </p>
            <button
              type="button"
              className="btn btn-outline-danger"
              onClick={reloadApplication}
            >
              <i className="bi bi-arrow-clockwise me-2"></i>
              Odśwież aplikację
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
